import { observer } from 'mobx-react-lite'
import { Alert } from 'shared/ui'
import { type BusinessHoursStore } from '../../store/BusinessHoursStore.ts'

type IActionEditContentProps = {
  store: BusinessHoursStore
}

export const BusinessHoursEditContent = observer(({ store }: IActionEditContentProps) => {
  const { isBusinessHoursActive, businessHoursLink } = store

  if (isBusinessHoursActive) {
    return (
      <Alert
        item={{
          type: 'infoLight',
          desc: 'This action follows the hours set in Business Hours settings. To change the schedule, update it there.',
        }}
        actions={[
          {
            type: 'primary',
            variant: 'link',
            text: 'Go to Business Hours',
            link: businessHoursLink,
          },
        ]}
      />
    )
  } else {
    return (
      <Alert
        item={{
          type: 'warning',
          desc: "Business hours are turned off, so this action can't run. Turn them on to route calls by schedule.",
        }}
        actions={[
          {
            type: 'primary',
            variant: 'link',
            text: 'Go to Business Hours',
            link: businessHoursLink,
          },
        ]}
      />
    )
  }
})
